module.exports = __webpack_public_path__ + "img/touragency_plane.a79e8860.svg";